import { render, staticRenderFns } from "./formPredata.vue?vue&type=template&id=6a003068&scoped=true&"
import script from "./formPredata.vue?vue&type=script&lang=js&"
export * from "./formPredata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a003068",
  null
  
)

export default component.exports